import Video from './VideoContainer.js'
import VideoComponent from './VideoComponent.js'
import PlayButton from './PlayButton'
export default Video
export { Video, VideoComponent, PlayButton }
